// extracted by mini-css-extract-plugin
export default {"progressContainer":"styles_progressContainer__AguWi","progressBar":"styles_progressBar__AAu7e"};